import { h } from "vue";
import { RouteRecordRaw, RouterView } from "vue-router";

const routes: Array<RouteRecordRaw> = [
    //Orders
    {
        path: "/administration/orders",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Orders",
                meta: { title: "Aufträge" },
                component: () => import("@/views/administration/orders/Orders.vue"),
            },
            {
                path: "create/:customerId?/:tab?",
                name: "OrderCreate",
                meta: { title: "Aufträge" },
                component: () => import("@/views/administration/orders/Order.vue"),
                props: true,
            },
            {
                path: ":id/edit/:tab?",
                name: "OrderEdit",
                meta: { title: "Aufträge" },
                component: () => import("@/views/administration/orders/Order.vue"),
                props: true,
            },
        ],
    },

    //MealPLan Order
    {
        path: "/kunden/speiseplan",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "bestellung",
                name: "MealPlanOrder",
                meta: { title: "Speiseplan Bestellung" },
                component: () => import("@/views/administration/mealplans/customer/MealPlanOrder.vue"),
            },
        ],
    },

    //MealPLans
    {
        path: "/administration/mealplans",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "MealPlans",
                meta: { title: "Speisepläne" },
                component: () => import("@/views/administration/mealplans/MealPlans.vue"),
            },
            {
                path: "create/:tab?",
                name: "MealPlanCreate",
                meta: { title: "Speisepläne" },
                component: () => import("@/views/administration/mealplans/MealPlan.vue"),
                props: true,
            },
            {
                path: ":id/edit/:tab?",
                name: "MealPlanEdit",
                meta: { title: "Speisepläne" },
                component: () => import("@/views/administration/mealplans/MealPlan.vue"),
                props: true,
            },
            {
                path: ":mealPlanId/menus/createMenu/:tab?",
                name: "MenuCreate",
                meta: { title: "Speisepläne" },
                component: () => import("@/views/administration/mealplans/menus/Menu.vue"),
                props: true,
            },
            {
                path: ":mealPlanId/menus/:id/editMenu/:tab?",
                name: "MenuEdit",
                meta: { title: "Speisepläne" },
                component: () => import("@/views/administration/mealplans/menus/Menu.vue"),
                props: true,
            },
        ],
    },

    //MealPLans
    {
        path: "/administration/assignedplans",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "AssignedPlans",
                meta: { title: "Zuweisung Speisepläne" },
                component: () => import("@/views/administration/assignedplans/AssignedPlans.vue"),
            },
            {
                path: "create/:tab?",
                name: "AssignedPlanCreate",
                meta: { title: "Zuweisung Speisepläne" },
                component: () => import("@/views/administration/assignedplans/AssignedPlan.vue"),
                props: true,
            },
            {
                path: ":id/edit/:tab?",
                name: "AssignedPlanEdit",
                meta: { title: "Zuweisung Speisepläne" },
                component: () => import("@/views/administration/assignedplans/AssignedPlan.vue"),
                props: true,
            },
        ],
    },

    // Customers
    {
        path: "/administration/customers",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Customers",
                meta: { title: "Kunden" },
                component: () => import("@/views/administration/customers/Customers.vue"),
            },
            {
                path: "create/:tab?",
                name: "CustomerCreate",
                meta: { title: "Kunden" },
                component: () => import("@/views/administration/customers/components/Customer.vue"),
            },
            {
                path: ":id/edit/:tab?",
                name: "CustomerEdit",
                meta: { title: "Kunden" },
                component: () => import("@/views/administration/customers/components/Customer.vue"),
                props: true,
            },
            {
                path: ":customerId/contacts/create",
                name: "CustomerContactCreate",
                meta: { title: "Kunden" },
                component: () => import("@/views/administration/customers/components/ContactPerson.vue"),
                props: true,
            },
            {
                path: ":customerId/contacts/:id/edit",
                name: "CustomerContactEdit",
                meta: { title: "Kunden" },
                component: () => import("@/views/administration/customers/components/ContactPerson.vue"),
                props: true,
            },
        ],
    },

    //Appointments
    {
        path: "/administration/appointments",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Appointments",
                meta: { title: "Termine" },
                component: () => import("@/views/administration/appointments/Appointments.vue"),
            },
            {
                path: "create",
                name: "AppointmentCreate",
                meta: { title: "Termine" },
                component: () => import("@/views/administration/appointments/components/Appointment.vue"),
            },
            {
                path: ":id/edit",
                name: "AppointmentEdit",
                meta: { title: "Termine" },
                component: () => import("@/views/administration/appointments/components/Appointment.vue"),
                props: true,
            },
        ],
    },

    // Suppliers
    {
        path: "/administration/suppliers",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Suppliers",
                meta: { title: "Lieferanten" },
                component: () => import("@/views/administration/suppliers/Suppliers.vue"),
            },
            {
                path: "create/:tab?",
                name: "SupplierCreate",
                meta: { title: "Lieferanten" },
                component: () => import("@/views/administration/suppliers/components/Supplier.vue"),
            },
            {
                path: ":id/edit/:tab?",
                name: "SupplierEdit",
                meta: { title: "Lieferanten" },
                component: () => import("@/views/administration/suppliers/components/Supplier.vue"),
                props: true,
            },
            {
                path: ":supplierId/contacts/create",
                name: "SupplierContactCreate",
                meta: { title: "Lieferanten" },
                component: () => import("@/views/administration/suppliers/components/Contact.vue"),
                props: true,
            },
            {
                path: ":supplierId/contacts/:id/edit",
                name: "SupplierContactEdit",
                meta: { title: "Lieferanten" },
                component: () => import("@/views/administration/suppliers/components/Contact.vue"),
                props: true,
            },
        ],
    },

    // Cashbook Entries
    {
        path: "/administration/cashbook-entries",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "CashbookEntries",
                meta: { title: "Kassenbuch" },
                component: () => import("@/views/administration/cashbook-entries/CashbookEntries.vue"),
            },
            {
                path: ":cashBookId/create",
                name: "CashbookEntryCreate",
                meta: { title: "Kassenbuch" },
                component: () => import("@/views/administration/cashbook-entries/components/CashbookEntry.vue"),
                props: true,
            },
            {
                path: ":cashBookEntryId/edit",
                name: "CashbookEntryEdit",
                component: () => import("@/views/administration/cashbook-entries/components/CashbookEntry.vue"),
                props: true,
                meta : {
                    is : 'edit',
                    title: "Kassenbuch",
                }
            },
            {
                path: ":cashBookEntryId/view",
                name: "CashbookEntryView",
                component: () => import("@/views/administration/cashbook-entries/components/CashbookEntry.vue"),
                props: true,
                meta : {
                    is : 'view',
                    title: "Kassenbuch",
                }
            }
        ],
    },

    // Invoices
    {
        path: "/administration/invoices",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Invoices",
                meta: { title: "Rechnungen" },
                component: () => import("@/views/administration/invoices/Invoices.vue"),
            },
            {
                path: ":invoiceId/book",
                name: "InvoiceBook",
                meta: { title: "Rechnungen" },
                component: () => import("@/views/administration/invoices/Book.vue"),
                props: true,
            },
            {
                path: ":invoiceId/credit",
                name: "InvoiceCredit",
                meta: { title: "Rechnungen" },
                component: () => import("@/views/administration/invoices/Credit.vue"),
                props: true,
            },
        ],
    },

    //Exports
    {
        path: "/administration/exports",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Export",
                meta: { title: "Exporte" },
                component: () => import("@/views/administration/exports/Export.vue"),
            },
        ],
    },

    //Turnovers
    {
        path: "/administration/turnover",
        component: { render: () => h(RouterView) },
        children: [
            {
                path: "",
                name: "Turnover",
                meta: { title: "Umsatz" },
                component: () => import("@/views/administration/turnovers/Turnover.vue"),
            },
        ],
    },
];

export default routes;
